// HolidayCheck.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const HolidayCheck = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    de: "https://www.holidaycheck.de/wcf/hotelreview/rate/a62abac8-f302-3dad-a10b-8678e7e70ec4",
  };

  return (
    <>
      <button className="full-width-button" onClick={() => setShowModal(true)}>
        <i className="fa fa-star icon-space" />
        HolidayCheck
      </button>
      {showModal && (
        <LanguageModal
          title="HolidayCheck"
          icon="fa fa-star"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default HolidayCheck;
